import { Link } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Seo from "@/components/feature/Seo";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickEntry from "@/pages/home/components/CategoryQuickEntry";
import LatestMediaList from "@/pages/home/components/LatestMediaList";
import HotSidebar from "@/pages/home/components/HotSidebar";
import { featuredIds, getMediaById } from "@/mocks/media";

const featured = featuredIds
  .map((id) => getMediaById(id))
  .filter((item): item is NonNullable<typeof item> => Boolean(item));

export default function Home() {
  return (
    <SiteLayout active="home">
      <Seo
        title="91视频网站 - 最新电影电视剧资源在线观看平台"
        description="91视频网站提供丰富的最新电影、电视剧和综艺节目资源，涵盖多种类型和题材，满足用户在线观看和影视内容浏览需求，打造优质的视听体验。"
        keywords="91视频网站,在线视频观看,影视资源,电影下载,电视剧全集,高清剧集,在线观看影视,视频播放"
      />

      <HeroCarousel items={featured} />

      <div className="w-full px-4 md:px-6 xl:px-10">
        <div className="py-6 md:py-8 -mt-8 relative z-20">
          <CategoryQuickEntry />
        </div>

        <div className="flex flex-col lg:flex-row gap-6 md:gap-8 pb-12 md:pb-16">
          <div className="flex-1 min-w-0">
            <LatestMediaList />
          </div>
          <HotSidebar />
        </div>

        <section
          aria-label="网站简介"
          className="mb-12 md:mb-16 rounded-lg bg-background-100 border border-background-200 p-5 md:p-8 flex flex-col md:flex-row md:items-center gap-5 md:gap-8"
        >
          <div className="flex-1">
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
              关于 91视频网站
            </h2>
            <p className="mt-2.5 text-sm leading-7 text-foreground-600 max-w-3xl">
              91视频网站是一个面向影视爱好者的内容浏览平台，汇集最新电影、连载电视剧与热门综艺信息。
              你可以按频道、类型、地区、年份筛选作品，查看剧情简介与演职信息，也可以直接搜索片名快速定位。
              站内所有作品资料均为虚构示例，仅用于展示页面结构与交互体验。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2 shrink-0">
            <Link
              to="/about"
              className="h-10 px-5 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              了解我们
            </Link>
            <Link
              to="/search"
              className="h-10 px-5 inline-flex items-center rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line mr-1.5"></i>
              搜索影视
            </Link>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}